import { PROJECT_NAME } from '@/config/setting';
import LzdUtil from './lzd-util';
import { GLOBAL_ROLE_REF } from '@/api';

/**
 * 修改浏览器标题
 * @param title 标题
 */
export function setPageTitle(title?: string) {
  const names: string[] = [];
  if (LzdUtil.getAuthorizationToken() && LzdUtil.getRoleCode()) {
    const roleName = GLOBAL_ROLE_REF[LzdUtil.getRoleCode()];
    roleName && names.push(roleName);
  }
  if (title) {
    names.push(title);
  }
  if (PROJECT_NAME) {
    names.push(PROJECT_NAME);
  }
  document.title = names.join(' - ');
}
